module.exports = __webpack_public_path__ + "img/agd-lg.05c8ef42.svg";